// Hook for biological entities data
import { useState, useEffect } from 'react';
import { biologicalEntityService } from '../services/firebaseService';

export function useBiologicalEntities() {
  const [biological_entities, setBiologicalEntities] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  
  useEffect(() => {
    const loadBiologicalEntities = async () => {
      try {
        setLoading(true);
        console.log('🦠 Loading biological entities from Firebase...');
        const entities = await biologicalEntityService.getAll();
        console.log(`✅ Loaded ${entities.length} biological entities`);
        
        // Sort entities by scientific name or common name
        entities.sort((a, b) => {
          const nameA = (a.scientificName || a.commonName || '').toLowerCase();
          const nameB = (b.scientificName || b.commonName || '').toLowerCase();
          return nameA.localeCompare(nameB);
        });
        
        setBiologicalEntities(entities);
        setError(null);
      } catch (error) {
        console.error('❌ Error loading biological entities:', error);
        setError(error);
        setBiologicalEntities([]);
      } finally {
        setLoading(false);
      }
    };
    
    loadBiologicalEntities();
  }, []);
  
  const refresh = async () => {
    try {
      setLoading(true);
      const entities = await biologicalEntityService.getAll();
      
      // Sort entities by scientific name or common name
      entities.sort((a, b) => {
        const nameA = (a.scientificName || a.commonName || '').toLowerCase();
        const nameB = (b.scientificName || b.commonName || '').toLowerCase();
        return nameA.localeCompare(nameB);
      });
      
      setBiologicalEntities(entities);
      setError(null);
    } catch (err) {
      console.error('Error refreshing biological entities:', err);
      setError(err);
      setBiologicalEntities([]);
    } finally {
      setLoading(false);
    }
  };
  
  // Helper functions
  const getEntitiesByCategory = (category) => {
    return biological_entities.filter(entity => entity.category === category);
  };
  
  const getEntitiesByPriority = (priority) => {
    return biological_entities.filter(entity => entity.priority === priority);
  };
  
  const searchEntities = (query) => {
    if (!query) return biological_entities;
    
    const lowercaseQuery = query.toLowerCase();
    return biological_entities.filter(entity =>
      entity.name?.toLowerCase().includes(lowercaseQuery) ||
      entity.category?.toLowerCase().includes(lowercaseQuery) ||
      entity.description?.toLowerCase().includes(lowercaseQuery)
    );
  };
  
  return {
    biological_entities,
    loading,
    error,
    refresh,
    getEntitiesByCategory,
    getEntitiesByPriority,
    searchEntities
  };
}
